// territoryImageData.js
const territoryImageData = {
    Alaska: {
      0: require('./Assets/Images/GameBoard/WorldMap/Alaska/Alaska.png'),
      1: require('./Assets/Images/GameBoard/WorldMap/Alaska/AlaskaBlue.png'),
      2: require('./Assets/Images/GameBoard/WorldMap/Alaska/AlaskaGreen.png'),
      3: require('./Assets/Images/GameBoard/WorldMap/Alaska/AlaskaRed.png'),
      4: require('./Assets/Images/GameBoard/WorldMap/Alaska/AlaskaPink.png'),
      5: require('./Assets/Images/GameBoard/WorldMap/Alaska/AlaskaYellow.png'),
      6: require('./Assets/Images/GameBoard/WorldMap/Alaska/AlaskaPurple.png'),
      // Add more mappings for Alaska if needed
    },

    NorthWestTerritory: {
        0: require('./Assets/Images/GameBoard/WorldMap/NorthWestTerritory/NorthWestTerritory.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/NorthWestTerritory/NorthWestTerritoryBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/NorthWestTerritory/NorthWestTerritoryGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/NorthWestTerritory/NorthWestTerritoryRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/NorthWestTerritory/NorthWestTerritoryPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/NorthWestTerritory/NorthWestTerritoryYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/NorthWestTerritory/NorthWestTerritoryPurple.png'),
        
    },
    
    Alberta: {
        0: require('./Assets/Images/GameBoard/WorldMap/Alberta/Alberta.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Alberta/AlbertaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Alberta/AlbertaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Alberta/AlbertaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Alberta/AlbertaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Alberta/AlbertaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Alberta/AlbertaPurple.png'),
        
    },

    Ontario: {
        0: require('./Assets/Images/GameBoard/WorldMap/Ontario/Ontario.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Ontario/OntarioBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Ontario/OntarioGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Ontario/OntarioRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Ontario/OntarioPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Ontario/OntarioYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Ontario/OntarioPurple.png'),
        
    },

    Quebec: {
        0: require('./Assets/Images/GameBoard/WorldMap/Quebec/Quebec.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Quebec/QuebecBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Quebec/QuebecGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Quebec/QuebecRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Quebec/QuebecPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Quebec/QuebecYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Quebec/QuebecPurple.png'),
        
    },

    WesternUnitedStates: {
        0: require('./Assets/Images/GameBoard/WorldMap/WesternUnitedStates/WesternUnitedStates.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/WesternUnitedStates/WesternUnitedStatesBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/WesternUnitedStates/WesternUnitedStatesGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/WesternUnitedStates/WesternUnitedStatesRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/WesternUnitedStates/WesternUnitedStatesPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/WesternUnitedStates/WesternUnitedStatesYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/WesternUnitedStates/WesternUnitedStatesPurple.png'),
        
    }, 

    EasternUnitedStates: {
        0: require('./Assets/Images/GameBoard/WorldMap/EasternUnitedStates/EasternUnitedStates.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/EasternUnitedStates/EasternUnitedStatesBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/EasternUnitedStates/EasternUnitedStatesGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/EasternUnitedStates/EasternUnitedStatesRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/EasternUnitedStates/EasternUnitedStatesPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/EasternUnitedStates/EasternUnitedStatesYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/EasternUnitedStates/EasternUnitedStatesPurple.png'),
        
    }, 

    CentralAmerica: {
        0: require('./Assets/Images/GameBoard/WorldMap/CentralAmerica/CentralAmerica.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/CentralAmerica/CentralAmericaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/CentralAmerica/CentralAmericaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/CentralAmerica/CentralAmericaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/CentralAmerica/CentralAmericaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/CentralAmerica/CentralAmericaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/CentralAmerica/CentralAmericaPurple.png'),
        
    },

    Peru: {
        0: require('./Assets/Images/GameBoard/WorldMap/Peru/Peru.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Peru/PeruBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Peru/PeruGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Peru/PeruRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Peru/PeruPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Peru/PeruYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Peru/PeruPurple.png'),
        
    },

    Brazil: {
        //0: require('./Assets/Images/GameBoard/WorldMap/Brazil/Brazil.png'),
        0: require('./Assets/Images/GameBoard/WorldMap/Brazil/Brazil.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Brazil/BrazilBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Brazil/BrazilGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Brazil/BrazilRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Brazil/BrazilPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Brazil/BrazilYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Brazil/BrazilPurple.png'),
        
    },

    Argentina: {
        0: require('./Assets/Images/GameBoard/WorldMap/Argentina/Argentina.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Argentina/ArgentinaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Argentina/ArgentinaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Argentina/ArgentinaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Argentina/ArgentinaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Argentina/ArgentinaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Argentina/ArgentinaPurple.png'),
        
    },

    Greenland: {
        0: require('./Assets/Images/GameBoard/WorldMap/Greenland/Greenland.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Greenland/GreenlandBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Greenland/GreenlandGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Greenland/GreenlandRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Greenland/GreenlandPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Greenland/GreenlandYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Greenland/GreenlandPurple.png'),
        
    },

    Iceland: {
        0: require('./Assets/Images/GameBoard/WorldMap/Iceland/Iceland.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Iceland/IcelandBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Iceland/IcelandGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Iceland/IcelandRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Iceland/IcelandPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Iceland/IcelandYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Iceland/IcelandPurple.png'),
        
    },

    GreatBritain: {
        0: require('./Assets/Images/GameBoard/WorldMap/GreatBritain/GreatBritain.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/GreatBritain/GreatBritainBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/GreatBritain/GreatBritainGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/GreatBritain/GreatBritainRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/GreatBritain/GreatBritainPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/GreatBritain/GreatBritainYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/GreatBritain/GreatBritainPurple.png'),
        
    },

    Scandinavia: {
        0: require('./Assets/Images/GameBoard/WorldMap/Scandinavia/Scandinavia.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Scandinavia/ScandinaviaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Scandinavia/ScandinaviaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Scandinavia/ScandinaviaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Scandinavia/ScandinaviaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Scandinavia/ScandinaviaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Scandinavia/ScandinaviaPurple.png'),
        
    },

    NorthernEurope: {
        0: require('./Assets/Images/GameBoard/WorldMap/NorthernEurope/NorthernEurope.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/NorthernEurope/NorthernEuropeBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/NorthernEurope/NorthernEuropeGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/NorthernEurope/NorthernEuropeRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/NorthernEurope/NorthernEuropePink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/NorthernEurope/NorthernEuropeYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/NorthernEurope/NorthernEuropePurple.png'),
        
    },

    WesternEurope: {
        0: require('./Assets/Images/GameBoard/WorldMap/WesternEurope/WesternEurope.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/WesternEurope/WesternEuropeBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/WesternEurope/WesternEuropeGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/WesternEurope/WesternEuropeRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/WesternEurope/WesternEuropePink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/WesternEurope/WesternEuropeYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/WesternEurope/WesternEuropePurple.png'),
        
    },

    SouthernEurope: {
        0: require('./Assets/Images/GameBoard/WorldMap/SouthernEurope/SouthernEurope.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/SouthernEurope/SouthernEuropeBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/SouthernEurope/SouthernEuropeGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/SouthernEurope/SouthernEuropeRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/SouthernEurope/SouthernEuropePink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/SouthernEurope/SouthernEuropeYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/SouthernEurope/SouthernEuropePurple.png'),
        
    },

    Ukraine: {
        0: require('./Assets/Images/GameBoard/WorldMap/Ukraine/Ukraine.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Ukraine/UkraineBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Ukraine/UkraineGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Ukraine/UkraineRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Ukraine/UkrainePink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Ukraine/UkraineYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Ukraine/UkrainePurple.png'),
        
    },

    Ural: {
        0: require('./Assets/Images/GameBoard/WorldMap/Ural/Ural.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Ural/UralBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Ural/UralGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Ural/UralRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Ural/UralPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Ural/UralYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Ural/UralPurple.png'),
        
    },

    Afganistan: {
        0: require('./Assets/Images/GameBoard/WorldMap/Afganistan/Afganistan.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Afganistan/AfganistanBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Afganistan/AfganistanGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Afganistan/AfganistanRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Afganistan/AfganistanPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Afganistan/AfganistanYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Afganistan/AfganistanPurple.png'),
        
    },

    MiddleEast: {
        0: require('./Assets/Images/GameBoard/WorldMap/MiddleEast/MiddleEast.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/MiddleEast/MiddleEastBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/MiddleEast/MiddleEastGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/MiddleEast/MiddleEastRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/MiddleEast/MiddleEastPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/MiddleEast/MiddleEastYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/MiddleEast/MiddleEastPurple.png'),
        
    },

    India: {
        0: require('./Assets/Images/GameBoard/WorldMap/India/India.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/India/IndiaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/India/IndiaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/India/IndiaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/India/IndiaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/India/IndiaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/India/IndiaPurple.png'),
        
    },

    China: {
        0: require('./Assets/Images/GameBoard/WorldMap/China/China.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/China/ChinaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/China/ChinaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/China/ChinaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/China/ChinaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/China/ChinaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/China/ChinaPurple.png'),
        
    },

    Siberia: {
        0: require('./Assets/Images/GameBoard/WorldMap/Siberia/Siberia.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Siberia/SiberiaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Siberia/SiberiaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Siberia/SiberiaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Siberia/SiberiaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Siberia/SiberiaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Siberia/SiberiaPurple.png'),
        
    },

    Tajakistan: {
        0: require('./Assets/Images/GameBoard/WorldMap/SiberiaRight/SiberiaRight.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/SiberiaRight/SiberiaRightBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/SiberiaRight/SiberiaRightGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/SiberiaRight/SiberiaRightRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/SiberiaRight/SiberiaRightPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/SiberiaRight/SiberiaRightYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/SiberiaRight/SiberiaRightPurple.png'),
        
    },

    Syria: {
        0: require('./Assets/Images/GameBoard/WorldMap/ChinaTop/ChinaTop.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/ChinaTop/ChinaTopBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/ChinaTop/ChinaTopGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/ChinaTop/ChinaTopRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/ChinaTop/ChinaTopPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/ChinaTop/ChinaTopYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/ChinaTop/ChinaTopPurple.png'),
        
    },

    Mangolia: {
        0: require('./Assets/Images/GameBoard/WorldMap/Mangolia/Mangolia.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Mangolia/MangoliaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Mangolia/MangoliaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Mangolia/MangoliaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Mangolia/MangoliaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Mangolia/MangoliaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Mangolia/MangoliaPurple.png'),
        
    },

    IRKLITSK: {
        0: require('./Assets/Images/GameBoard/WorldMap/IRKLITSK/IRKLITSK.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/IRKLITSK/IRKLITSKBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/IRKLITSK/IRKLITSKGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/IRKLITSK/IRKLITSKRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/IRKLITSK/IRKLITSKPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/IRKLITSK/IRKLITSKYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/IRKLITSK/IRKLITSKPurple.png'),
        
    },

    Nigeria: {
        0: require('./Assets/Images/GameBoard/WorldMap/IRKLITSKTop/IRKLITSKTop.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/IRKLITSKTop/IRKLITSKTopBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/IRKLITSKTop/IRKLITSKTopGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/IRKLITSKTop/IRKLITSKTopRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/IRKLITSKTop/IRKLITSKTopPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/IRKLITSKTop/IRKLITSKTopYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/IRKLITSKTop/IRKLITSKTopPurple.png'),
        
    },

    YAKLITSK: {
        0: require('./Assets/Images/GameBoard/WorldMap/YAKLITSK/YAKLITSK.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/YAKLITSK/YAKLITSKBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/YAKLITSK/YAKLITSKGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/YAKLITSK/YAKLITSKRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/YAKLITSK/YAKLITSKPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/YAKLITSK/YAKLITSKYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/YAKLITSK/YAKLITSKPurple.png'),
        
    },

    //

    Kamchatka: {
        0: require('./Assets/Images/GameBoard/WorldMap/Kamchatka/Kamchatka.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Kamchatka/KamchatkaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Kamchatka/KamchatkaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Kamchatka/KamchatkaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Kamchatka/KamchatkaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Kamchatka/KamchatkaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Kamchatka/KamchatkaPurple.png'),
        
    },

    Slam: {
        0: require('./Assets/Images/GameBoard/WorldMap/Slam/Slam.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Slam/SlamBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Slam/SlamGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Slam/SlamRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Slam/SlamPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Slam/SlamYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Slam/SlamPurple.png'),
        
    },

    Indonesia: {
        0: require('./Assets/Images/GameBoard/WorldMap/Indonesia/Indonesia.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Indonesia/IndonesiaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Indonesia/IndonesiaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Indonesia/IndonesiaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Indonesia/IndonesiaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Indonesia/IndonesiaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Indonesia/IndonesiaPurple.png'),
        
    },

    NewGuinea: {
        0: require('./Assets/Images/GameBoard/WorldMap/NewGuinea/NewGuinea.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/NewGuinea/NewGuineaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/NewGuinea/NewGuineaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/NewGuinea/NewGuineaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/NewGuinea/NewGuineaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/NewGuinea/NewGuineaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/NewGuinea/NewGuineaPurple.png'),
        
    },

    EasternAustralia: {
        0: require('./Assets/Images/GameBoard/WorldMap/EasternAustralia/EasternAustralia.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/EasternAustralia/EasternAustraliaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/EasternAustralia/EasternAustraliaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/EasternAustralia/EasternAustraliaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/EasternAustralia/EasternAustraliaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/EasternAustralia/EasternAustraliaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/EasternAustralia/EasternAustraliaPurple.png'),
        
    },

    WesternAustralia: {
        0: require('./Assets/Images/GameBoard/WorldMap/WesternAustralia/WesternAustralia.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/WesternAustralia/WesternAustraliaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/WesternAustralia/WesternAustraliaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/WesternAustralia/WesternAustraliaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/WesternAustralia/WesternAustraliaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/WesternAustralia/WesternAustraliaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/WesternAustralia/WesternAustraliaPurple.png'),
        
    },

    Japan: {
        0: require('./Assets/Images/GameBoard/WorldMap/Japan/Japan.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Japan/JapanBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Japan/JapanGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Japan/JapanRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Japan/JapanPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Japan/JapanYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Japan/JapanPurple.png'),
        
    },

    //


    Greenland: {
        0: require('./Assets/Images/GameBoard/WorldMap/Greenland/Greenland.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Greenland/GreenlandBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Greenland/GreenlandGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Greenland/GreenlandRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Greenland/GreenlandPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Greenland/GreenlandYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Greenland/GreenlandPurple.png'),
        
    },

    // Africa
    NorthAfrica: {
        0: require('./Assets/Images/GameBoard/WorldMap/NorthAfrica/NorthAfrica.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/NorthAfrica/NorthAfricaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/NorthAfrica/NorthAfricaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/NorthAfrica/NorthAfricaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/NorthAfrica/NorthAfricaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/NorthAfrica/NorthAfricaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/NorthAfrica/NorthAfricaPurple.png'),
        
    },

    Egypt: {
        0: require('./Assets/Images/GameBoard/WorldMap/Egypt/Egypt.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Egypt/EgyptBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Egypt/EgyptGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Egypt/EgyptRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Egypt/EgyptPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Egypt/EgyptYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Egypt/EgyptPurple.png'),
        
    },

    EastAfrica: {
        0: require('./Assets/Images/GameBoard/WorldMap/EastAfrica/EastAfrica.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/EastAfrica/EastAfricaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/EastAfrica/EastAfricaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/EastAfrica/EastAfricaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/EastAfrica/EastAfricaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/EastAfrica/EastAfricaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/EastAfrica/EastAfricaPurple.png'),
        
    },

    Congo: {
        0: require('./Assets/Images/GameBoard/WorldMap/Congo/Congo.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Congo/CongoBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Congo/CongoGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Congo/CongoRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Congo/CongoPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Congo/CongoYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Congo/CongoPurple.png'),
        
    },

    SouthAfrica: {
        0: require('./Assets/Images/GameBoard/WorldMap/SouthAfrica/SouthAfrica.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/SouthAfrica/SouthAfricaBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/SouthAfrica/SouthAfricaGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/SouthAfrica/SouthAfricaRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/SouthAfrica/SouthAfricaPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/SouthAfrica/SouthAfricaYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/SouthAfrica/SouthAfricaPurple.png'),
        
    },

    Madgascar: {
        0: require('./Assets/Images/GameBoard/WorldMap/Madgascar/Madgascar.png'),
        1: require('./Assets/Images/GameBoard/WorldMap/Madgascar/MadgascarBlue.png'),
        2: require('./Assets/Images/GameBoard/WorldMap/Madgascar/MadgascarGreen.png'),
        3: require('./Assets/Images/GameBoard/WorldMap/Madgascar/MadgascarRed.png'),
        4: require('./Assets/Images/GameBoard/WorldMap/Madgascar/MadgascarPink.png'),
        5: require('./Assets/Images/GameBoard/WorldMap/Madgascar/MadgascarYellow.png'),
        6: require('./Assets/Images/GameBoard/WorldMap/Madgascar/MadgascarPurple.png'),
        
    },


    // Africa
    
  };
  
  export default territoryImageData;
  